/**
 * @generated SignedSource<<7916225435a94285e1eca2599ae81398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CancelOrder_receipt$data = {
  readonly transactionFee: {
    readonly symbol: string;
    readonly unit: string;
    readonly usd: string;
  };
  readonly " $fragmentType": "CancelOrder_receipt";
};
export type CancelOrder_receipt$key = {
  readonly " $data"?: CancelOrder_receipt$data;
  readonly " $fragmentSpreads": FragmentRefs<"CancelOrder_receipt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CancelOrder_receipt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceType",
      "kind": "LinkedField",
      "name": "transactionFee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usd",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionReceiptType",
  "abstractKey": null
};

(node as any).hash = "8ecb56054a82b04383c6cf85f38a57f3";

export default node;
